import React from "react";
export function KpiTile({ label, value, delta, tone, style = {} }) {
  const c = tone ? "var(--ac-" + tone + ")" : "var(--fg-1)";
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 3, padding: "10px 14px", background: "var(--bg-sunken)", ...style }}>
      <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, fontSize: "var(--fs-11)", color: "var(--fg-8)" }}>
        {label}
        {delta ? <span style={{ padding: "1px 6px", borderRadius: "var(--r-pill)", background: "color-mix(in srgb, var(--ac-green) 16%, transparent)", color: "var(--ac-green)", fontSize: "var(--fs-10)", fontWeight: "var(--fw-semibold)" }}>{delta}</span> : null}
      </span>
      <span style={{ fontSize: "var(--fs-13)", fontWeight: "var(--fw-semibold)", color: c, fontVariantNumeric: "tabular-nums" }}>{value}</span>
    </div>
  );
}
